module.exports = "/dist/assets/images/android-chrome-192x192.png";